import { Modal } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import Cancel from "../../../../assets/cancel.svg";
import OtpInput from "react-otp-input";
import { useState } from "react";

const VehicleFinancePinModal = (props: any) => {
  const { pin, hideCloseIcon, closeModal } = props;
  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={400}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
        <div className={Styles.modalContentVerification}>
          {/* {hideCloseIcon==='' || null &&  */}
          <div className={Styles.cancelDiv}>
            <img
              style={{ display: closeModal ? 'none' : '' }}
              onClick={props.goToTerms}
              src={Cancel}
              className={Styles.cancelIcon}
              alt="horse"
            />
            <img
              style={{ display: closeModal ? '' : 'none' }}
              onClick={props.handleCancel}
              src={Cancel}
              className={Styles.cancelIcon}
              alt="horse"
            />
          </div>
          {/* } */}
          <div
            style={{ paddingTop: hideCloseIcon === '' || null ? "1.5em" : '0em' }}
            className={Styles.title}
          >
            Please enter your PIN
          </div>

          <div className={Styles.inputTitle} style={{ paddingTop: "1.5em", color: '#354764' }}>
            PIN
            {/* <span className={Styles.asteriks}>*</span> */}
          </div>
          {/* <OtpInput
            value={pin}
            onChange={props.onChangePinSelectChange}
            numInputs={4}
            inputType="password" 
            shouldAutoFocus={true}
            containerStyle={{ justifyContent: "space-between" }}
            inputStyle={Styles.otpInput}
            renderSeparator={<span> </span>}
            renderInput={(props) => <input {...props} />}
          /> */}
          <OtpInput
            value={pin}
            onChange={props.onChangePinSelectChange}
            numInputs={4}
            inputType="password" // Enables the masked input (••••)
            shouldAutoFocus={true}
            containerStyle={{ justifyContent: "space-between" }}
            inputStyle={Styles.otpInput}
            renderSeparator={<span> </span>}
            renderInput={(inputProps: any, index: number) => (
              <input
                {...inputProps}
                onKeyDown={(e) => {
                  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
                  const isNumber = /^\d$/.test(e.key);

                  // Allow only numbers and navigation
                  if (!isNumber && !allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }

                  // Handle Backspace to move focus back
                  if (e.key === "Backspace" && !inputProps.value) {
                    const prevInput = document.querySelectorAll('input')[index - 1] as HTMLInputElement;
                    if (prevInput) {
                      prevInput.focus();
                      prevInput.value = "";
                      e.preventDefault();
                    }
                  }
                }}
              />
              // <input
              //   {...inputProps}
              //   inputMode="numeric"   // Mobile keyboard hint
              //   pattern="\d*"         // Accept only digits
              //   onKeyDown={(e) => {
              //     const isAllowedKey =
              //       ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key) ||
              //       /^[0-9]$/.test(e.key);

              //     if (!isAllowedKey) {
              //       e.preventDefault();
              //     }
              //   }}
              // />
            )}
          />

          <button
            style={{ background: pin?.length < 4 ? "#d9d9d9" : "", marginTop: '2.5em' }}
            disabled={pin?.length < 4}
            onClick={props.verifyPin}
            className={Styles.btn}
          >
            SUBMIT
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default VehicleFinancePinModal;
